import styled from "styled-components";
import { Row, Col } from "react-bootstrap";
import {
  ContainerFrame,
  Link,
  ThumbnailBig,
  ThumbnailDiamond,
  FooterSection,
  LinkImage,
} from "@components";
import { Download, ChevronRight } from "@icons";

import Image9 from "../assets/images/image9.png";
import { ReportAPI, InvestorsBannerAPI, InvestorsBannerChildAPI } from "@api";
import { useState, useEffect } from "react";
import moment from "moment";
import { useTranslation } from "react-i18next";

const InvestorContainer = styled.div`
  padding-top: 56px;
  overflow: hidden;

  @media screen and (min-width: 767px) and (max-width: 991px){
    padding-top: 0;
  }

  @media screen and (max-width: 767px) {
    padding-top: 0;
  }
`;

const FooterCard = styled.div`
  padding: 48px 119px 88px 119px;

  @media screen and (max-width: 767px){
    padding: 40px 16px;
  }
`;

const Investor = function () {
  const { t } = useTranslation();
  const [annualReport, setAnnualReport] = useState(null);
  const [rupsReport, setRupsReport] = useState(null);
  const [investorsBanner, setInvestorsBanner] = useState(null);
  const [temuAnalis, setTemuAnalis] = useState(null);
  const [publicExpose, setPublicExpose] = useState(null);
  const [prospektus, setProspektus] = useState(null);
  const [kepemilikanSaham, setKepemilikanSaham] = useState(null);
  const [dividen, setDividen] = useState(null);
  const [obligasi, setObligasi] = useState(null);
  const [penerbitanObligasi, setPenerbitanObligasi] = useState(null);
  const [pencatatanSaham, setPencatatanSaham] = useState(null);
  const [lapKeuanganTriwulan, setLapKeuanganTriwulan] = useState(null);
  const [lapKeuanganBulanan, setLapKeuanganBulanan] = useState(null);
  const [rasioPendapatan, setRasioPendapatan] = useState(null);

  useEffect(() => {
    const loadAnnualReport = async () => {
      const { data } = await ReportAPI({
        cat: "laporan_tahunan",
        from: "2010-01-30",
        to: moment().format("YYYY-MM-DD"),
        limit: "4",
        page: 1,
      });

      setAnnualReport(data.data.result);
    };
    const loadRupsReport = async () => {
      const { data } = await ReportAPI({
        cat: "rups",
        from: "2021-01-30",
        to: moment().format("YYYY-MM-DD"),
        limit: "4",
        page: 1,
      });      
      setRupsReport(data.data.result);
    };

    const loadInvestorBanner = async () => {
      const { data } = await InvestorsBannerAPI();
      setInvestorsBanner(data.data);
    };

    const loadTemuAnalis = async () => {
      const { data } = await InvestorsBannerChildAPI({
        category: "temu_analis",
      });
      setTemuAnalis(data.data);
    };

    const loadPublicExpose = async () => {
      const { data } = await InvestorsBannerChildAPI({
        category: "public_expose",
      });
      setPublicExpose(data.data);
    };

    const loadProspektus = async () => {
      const { data } = await InvestorsBannerChildAPI({
        category: "prospketus",
      });
      setProspektus(data.data);
    };

    const loadKepemilikanSaham = async () => {
      const { data } = await InvestorsBannerChildAPI({
        category: "kepemilikan_saham",
      });
      setKepemilikanSaham(data.data);
    };

    const loadDividen = async () => {
      const { data } = await InvestorsBannerChildAPI({
        category: "dividen",
      });
      setDividen(data.data);
    };

    const loadObligasi = async () => {
      const { data } = await InvestorsBannerChildAPI({
        category: "obligasi",
      });
      setObligasi(data.data);
    };

    const loadPenerbitanObligasi = async () => {
      const { data } = await InvestorsBannerChildAPI({
        category: "penerbitan_obligasi",
      });
      setPenerbitanObligasi(data.data);
    };

    const loadPencatatanSaham = async () => {
      const { data } = await InvestorsBannerChildAPI({
        category: "pencatatan_saham",
      });
      setPencatatanSaham(data.data);
    };

    const loadLapKeuanganTriwulan = async () => {
      const { data } = await InvestorsBannerChildAPI({
        category: "lap_keuangan_tri",
      });      
      setLapKeuanganTriwulan(data.data);
    };

    const loadLapKeuanganBulanan = async () => {
      const { data } = await InvestorsBannerChildAPI({
        category: "lap_keuangan_bul",
      });
      setLapKeuanganBulanan(data.data);
    };

    const loadRasioPenpatan = async () => {
      const { data } = await InvestorsBannerChildAPI({
        category: "rasio_pendapatan",
      });
      setRasioPendapatan(data.data);
    };

    if (!investorsBanner) {
      loadInvestorBanner();
    }

    if (!temuAnalis) {
      loadTemuAnalis();
    }

    if (!publicExpose) {
      loadPublicExpose();
    }

    if (!prospektus) {
      loadProspektus();
    }

    if (!kepemilikanSaham) {
      loadKepemilikanSaham();
    }

    if (!dividen) {
      loadDividen();
    }

    if (!obligasi) {
      loadObligasi();
    }

    if (!penerbitanObligasi) {
      loadPenerbitanObligasi();
    }

    if (!pencatatanSaham) {
      loadPencatatanSaham();
    }

    if (!lapKeuanganTriwulan) {
      loadLapKeuanganTriwulan();
    }

    if (!lapKeuanganBulanan) {
      loadLapKeuanganBulanan();
    }

    if (!rasioPendapatan) {
      loadRasioPenpatan();
    }

    if (!annualReport) {
      loadAnnualReport();
    }

    if (!rupsReport) {
      loadRupsReport();
    }
  }, [annualReport, rupsReport, investorsBanner, temuAnalis, publicExpose, prospektus, kepemilikanSaham, dividen, obligasi, pencatatanSaham, penerbitanObligasi, lapKeuanganTriwulan, lapKeuanganBulanan, rasioPendapatan]);

  return (
    <InvestorContainer>
      <Row xs="12">
        <ThumbnailBig
          title={investorsBanner !== null ? investorsBanner.title : ""}
          desc={investorsBanner !== null ? investorsBanner.description : ""}
          img={investorsBanner !== null ? investorsBanner.mainBanner : ""}
        />
      </Row>
      <ContainerFrame>
        <Row className="py-5">
          <Col xs="12" md="6">
            <ThumbnailDiamond
              image={
                investorsBanner !== null ? investorsBanner.subBanner1 : Image9
              }
            />
          </Col>
          <Col xs="12" md="6">
            <div>
              <div
                className="d-flex bd-highlight align-items-center py-2"
                style={{ borderBottom: "#EDEEEE thin solid" }}
              >
                <div
                  className="d-flex text-start w-100 bd-highlight"
                  style={{ fontSize: "1.5em", fontWeight: "600" }}
                >
                  {investorsBanner !== null ? investorsBanner.subTitle1 : `${t("laporan_tahunan")}`}
                </div>
                <div
                  className="p-2 flex-shrink-1 bd-highlight cursor-pointer"
                  style={{ color: "#F2A900", fontWeight: "600" }}
                  onClick={() => {
                    window.location.href = "/annual-report";
                  }}
                >
                  {t("more")}
                </div>
              </div>
              <div>
                {annualReport !== null
                  ? annualReport.map((report, i) => {
                      return (
                        <Link
                          label={moment(
                            report.created_date,
                            "DD-MM-YYYY hh:mm:ss"
                          ).format("YYYY")}
                          title={report.title}
                          icon={Download}
                          key={i}
                          file={report.file}
                        />
                      );
                    })
                  : ""}
              </div>
            </div>
          </Col>
        </Row>
      </ContainerFrame>
      <ContainerFrame background="#F9F9F9">
        <Row className="py-5">
          <Col xs="12" md="6">
            <div>
              <div
                className="d-flex bd-highlight align-items-center py-2"
                style={{ borderBottom: "#EDEEEE thin solid" }}
              >
                <div
                  className="d-flex text-start w-100 bd-highlight"
                  style={{ fontSize: "1.5em", fontWeight: "600" }}
                >
                  {investorsBanner !== null ? investorsBanner.subTitle2 : `${t("laporan_keuangan")}`}
                </div>
              </div>
              <div>
                <Link
                  title={lapKeuanganTriwulan !== null ? lapKeuanganTriwulan.title : `${t("laporan_keuangan_triwulan")}` }
                  icon={ChevronRight}
                  href={lapKeuanganTriwulan !== null ? lapKeuanganTriwulan.link : "/financial-report"}
                />
                <Link
                  title={lapKeuanganBulanan !== null ? lapKeuanganBulanan.title : `${t("laporan_keuangan_bulanan")}`}
                  icon={ChevronRight}
                  href={lapKeuanganBulanan !== null ? lapKeuanganBulanan.link : "/financial-report/#bulanan"}
                />
                {/* <Link
                  title={rasioPendapatan !== null ? rasioPendapatan.title : ""}
                  icon={ChevronRight}
                  href={rasioPendapatan !== null ? rasioPendapatan.link : ""}
                /> */}
              </div>
            </div>
          </Col>
          <Col xs="12" md="6">
            <ThumbnailDiamond
              image={
                investorsBanner !== null ? investorsBanner.subBanner2 : Image9
              }
            />
          </Col>
        </Row>
      </ContainerFrame>
      <ContainerFrame>
        <Row className="py-5">
          <Col xs="12" md="6">
            <ThumbnailDiamond
              image={
                investorsBanner !== null ? investorsBanner.subBanner3 : Image9
              }
            />
          </Col>
          <Col xs="12" md="6">
            <div>
              <div
                className="d-flex bd-highlight align-items-center py-2"
                style={{ borderBottom: "#EDEEEE thin solid" }}
              >
                <div
                  className="d-flex text-start w-100 bd-highlight"
                  style={{ fontSize: "1.5em", fontWeight: "600" }}
                >
                  {investorsBanner !== null ? investorsBanner.subTitle3 : `${t("RUPS")}`}
                </div>
                <div
                  className="p-2 flex-shrink-1 bd-highlight cursor-pointer"
                  style={{ color: "#F2A900", fontWeight: "600" }}
                  onClick={() => {
                    window.location.href = "/rups";
                  }}
                >
                  {t("more")}
                </div>
              </div>
              <div>
                {rupsReport !== null
                  ? rupsReport.map((report, i) => {
                      return (
                        <Link
                          label={moment(
                            report.created_date,
                            "DD-MM-YYYY hh:mm:ss"
                          ).format("DD MMM YYYY")}
                          title={report.title}
                          icon={Download}
                          key={i}
                          file={report.file}
                        />
                      );
                    })
                  : ""}
              </div>
            </div>
          </Col>
        </Row>
      </ContainerFrame>
      <ContainerFrame background="#F9F9F9">
        <Row className="py-5">
          <Col xs="12" md="6">
            <div>
              <div
                className="d-flex bd-highlight align-items-center py-2"
                style={{ borderBottom: "#EDEEEE thin solid" }}
              >
                <div
                  className="d-flex text-start w-100 bd-highlight"
                  style={{ fontSize: "1.5em", fontWeight: "600" }}
                >
                  {investorsBanner !== null ? investorsBanner.subTitle4 : `${t("riwayat_aksi_dan_korporasi")}`}
                </div>
              </div>
              <div>
                <Link
                  title={penerbitanObligasi !== null ? penerbitanObligasi.title : `${t("penerbitan_obligasi_subordinasi")}`}
                  icon={ChevronRight}
                  href={penerbitanObligasi !== null ? penerbitanObligasi.link : "/corporate-action"}
                />
                <Link
                  title={pencatatanSaham !== null ? pencatatanSaham.title : `${t("kronologis_pencatatan_saham")}`}
                  icon={ChevronRight}
                  href={pencatatanSaham !== null ? pencatatanSaham.link : "/corporate-action/#kronologis-pencatatan-saham"}
                />
              </div>
            </div>
          </Col>
          <Col xs="12" md="6">
            <ThumbnailDiamond
              image={
                investorsBanner !== null ? investorsBanner.subBanner4 : Image9
              }
            />
          </Col>
        </Row>
      </ContainerFrame>
      <ContainerFrame>
        <Row className="py-5">
          <Col xs="12" md="6">
            <ThumbnailDiamond
              image={
                investorsBanner !== null ? investorsBanner.subBanner5 : Image9
              }
            />
          </Col>
          <Col xs="12" md="6">
            <div>
              <div
                className="d-flex bd-highlight align-items-center py-2"
                style={{ borderBottom: "#EDEEEE thin solid" }}
              >
                <div
                  className="d-flex text-start w-100 bd-highlight"
                  style={{ fontSize: "1.5em", fontWeight: "600" }}
                >
                  {investorsBanner !== null ? investorsBanner.subTitle5 : `${t("informasi_saham_&_obligasi")}`}
                </div>
              </div>
              <div>
                <Link
                  title={kepemilikanSaham !== null ? kepemilikanSaham.title : `${t("kepemilikan_saham")}`}
                  icon={ChevronRight}
                  href={kepemilikanSaham !== null ? kepemilikanSaham.link : "/share-holders"}
                />
                <Link 
                  title={dividen !== null ? dividen.title : `${t("dividen")}`}
                  icon={ChevronRight} 
                  href={prospektus !== null ? prospektus.link : "/dividen"}
                />
                <Link 
                  title={obligasi !== null ? obligasi.title : `${t("obligasi")}`}
                  icon={ChevronRight} 
                  href={obligasi !== null ? obligasi.link : "/obligation"}
                />
              </div>
            </div>
          </Col>
        </Row>
      </ContainerFrame>
      <ContainerFrame background="#F9F9F9">
        <Row className="py-5">
          <Col xs="12" md="6">
            <div>
              <div
                className="d-flex bd-highlight align-items-center py-2"
                style={{ borderBottom: "#EDEEEE thin solid" }}
              >
                <div
                  className="d-flex text-start w-100 bd-highlight"
                  style={{ fontSize: "1.5em", fontWeight: "600" }}
                >
                  {investorsBanner !== null ? investorsBanner.subTitle6 : `${t("materi_investor")}`}
                </div>
              </div>
              <div>
                <Link
                  title={prospektus !== null ? prospektus.title : `${t("prospektus")}`}
                  icon={ChevronRight}
                  href={prospektus !== null ? prospektus.link : "/prospectus"}
                />
                <Link
                  title={publicExpose !== null ? publicExpose.title : `${t("public_expose")}`}
                  icon={ChevronRight}
                  href={publicExpose !== null ? publicExpose.link : "/public-expose"}
                />
                <Link
                  title={temuAnalis !== null ? temuAnalis.title :  `${t("presentasi_perusahaan")}`}
                  icon={ChevronRight}
                  href={temuAnalis !== null ? temuAnalis.link : "/analyst-meeting"}
                />
              </div>
            </div>
          </Col>
          <Col xs="12" md="6">
            <ThumbnailDiamond
              image={
                investorsBanner !== null ? investorsBanner.subBanner6 : Image9
              }
            />
          </Col>
        </Row>
      </ContainerFrame>
      <FooterCard>
        <Row>
          <Col xs="12" md="6">
              <a href="/agenda">
                <LinkImage image={investorsBanner !== null ? investorsBanner.kalenderAcara : Image9} label={investorsBanner !== null ? investorsBanner.judulCalendar : ""}/>
              </a>
          </Col>
          <Col xs="12" md="6">
            <a href="/contact-us">
              <LinkImage image={investorsBanner !== null ? investorsBanner.kontakInvestor : Image9} label={investorsBanner !== null ? investorsBanner.judulInvest : ""}/>
            </a>
          </Col>
        </Row>
      </FooterCard>
      <FooterSection currentPage={t("call_investor")}/>
    </InvestorContainer>
  );
};

export default Investor;
